import {
	useMutation,
	useQuery,
	type UseQueryResult,
} from '@tanstack/react-query';
import usersService from '../services/usersService';

export const useGetSelf = (options?: {
	isEnabled: boolean;
}): UseQueryResult<User> => {
	return useQuery<User>({
		queryKey: ['user', 'self'],
		queryFn: () => usersService.getSelf(),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useAddSuperAdmin = () => {
	return useMutation({
		mutationKey: ['user'],
		mutationFn: (data: AddSuperAdminRequest) => usersService.create(data),
	});
};

export const useUpdateSuperAdmin = () => {
	return useMutation({
		mutationKey: ['user'],
		mutationFn: (data: Partial<UpdateSuperAdminRequest>) =>
			usersService.update(data),
	});
};

export const useDeleteMultipleUsers = () => {
	return useMutation({
		mutationKey: ['users'],
		mutationFn: (data: DeleteMultipleUsersRequest) =>
			usersService.deleteMultipleUsers(data),
	});
};

export const useUpdateUser = () => {
	return useMutation({
		mutationKey: ['user'],
		mutationFn: (data: Partial<UpdateUserRequest>) =>
			usersService.update(data),
	});
};

export const useDeleteUser = () => {
	return useMutation({
		mutationKey: ['users'],
		mutationFn: (id: number) => usersService.deleteSingleResource(id),
	});
};

export const useAddUser = () => {
	return useMutation({
		mutationKey: ['user'],
		mutationFn: (data: AddUserRequest) => usersService.create(data),
	});
};

export const useGetSingleUser = (
	id: number,
	options?: {
		isEnabled: boolean;
	},
) => {
	return useQuery({
		queryKey: ['user', id],
		queryFn: () =>
			usersService.getSingleResource(id, {
				getRelated: 'userAccounts',
			}),
		enabled: options?.isEnabled === false ? false : true,
		/*
		 * Size of the request is about 500B + response doesn't return userAccounts,
		 * because it's hardcoded on API. So can't set queryData in a smart way.
		 * I really don't think it's worth caching.
		 */
		staleTime: 0,
	});
};
